<template>
  <div class="products-redemption-center-page-content flex flex-col items-center w-full text-left">
    <!-- banner 包含移动端 -->
    <PageBanner :content="content.bannerInfo" />

    <PageBusinessCol :content="content.businessIntroduction" />

    <!-- 产品功能介绍 中间左右布局的内容 -->
    <PageFunction :content="content.featuresIntroduction" />

    <!-- 产品优势 -->
    <PageAdvantage :content="content.advantage" :extraTitleStyle="{ color: '#272E3B' }" />

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { ref, shallowReactive, onMounted, onUnmounted } from 'vue'
import { useSeoMeta } from 'nuxt/app'
const title = '口味王会员兑换中心'
const description = '品牌直营全品类线上聚合商城'
useSeoMeta({
  title,
  description,
})

const content = shallowReactive({
  bannerInfo: {
    banner: '/images/pages/products/redemption-center/r-d- (1).png',
    mobileBanner: '/images/mobile/products/kwwhydhzx.png'
  },
  businessIntroduction: {
    title: '产品业务介绍',
    description: [
      '平台以积分为纽带，通过多元兑换与互动场景，有效提升会员活跃度与品牌忠诚度',
      '2024年底，我们进一步完成积分体系战略升级，实施"积分拆分"，实现会员价值精细化运营与管理效能跨越式提升，为业务增长注入新动能'
    ],
    descImage: [
      '/images/pages/products/redemption-center/c- (3).png',
      '/images/pages/products/redemption-center/c- (2).png',
      '/images/pages/products/redemption-center/c- (1).png'
    ],
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    extraCardBackColor: 'bg-#FAFAFA',
    extraTitleClass: 'bg-#FAFAFA w-100%!',
    groups: [
      {
        title: '规模化用户体量',
        desc: '',
        descList: [
          '从口味王引流将近7200w+用户，为商家提供海量用户基础',

        ],
        icon: '/images/pages/products/redemption-center/f-i- (1).png',
        mainImage: '/images/pages/products/redemption-center/f- (1).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '商家中心',
        desc: '',
        descList: [
          '一站式店铺管理平台，助力商家高效上品、发货与运营',
        ],
        icon: '/images/pages/products/redemption-center/f-i- (2).png',
        mainImage: '/images/pages/products/redemption-center/r-d- (3).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '订单中心',
        desc: '',
        descList: [
          '全流程订单管理，状态实时更新，处理高效便捷',
        ],
        icon: '/images/pages/products/redemption-center/f-i- (3).png',
        mainImage: '/images/pages/products/redemption-center/f- (3).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '营销中心',
        desc: '',
        descList: ['提供丰富营销工具与活动，助力引爆流量，提升销售转化',],
        icon: '/images/pages/products/redemption-center/f-i- (4).png',
        mainImage: '/images/pages/products/redemption-center/f- (4).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '财务中心',
        desc: '',
        descList: [
          '清晰管理资金流水，账单明细一目了然，结算省心高效',
        ],
        icon: '/images/pages/products/redemption-center/f-i- (5).png',
        mainImage: '/images/pages/products/redemption-center/r-d- (4).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '客服中心',
        desc: '',
        descList: [
          '全渠道连接用户，智能客服助力提升服务效率与体验',
        ],
        icon: '/images/pages/products/redemption-center/f-i- (6).png',
        mainImage: '/images/pages/products/redemption-center/r-d- (5).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '数据中心',
        desc: '',
        descList: [
          '多维数据可视化分析，为业务决策提供精准数据支撑',
        ],
        icon: '/images/pages/products/redemption-center/f-i- (7).png',
        mainImage: '/images/pages/products/redemption-center/f- (7).png',
        direction: 'copywriting-to-image'
      }, {
        title: '消息中心',
        desc: '',
        descList: [
          '系统与交易信息实时触达，确保重要通知永不遗漏',
        ],
        icon: '/images/pages/products/redemption-center/f-i- (8).png',
        mainImage: '/images/pages/products/redemption-center/r-d- (2).png',
        direction: 'image-to-copywriting'
      },

    ]
  },
  advantage: {
    title: '产品优势',
    desc: '专业团队技术能力更强，运维有保障',
    background: '/images/pages/products/redemption-center/b-b.png',
    list: [
      {
        briefBack: '/images/pages/products/redemption-center/b- (1).png',
      },
      {
        briefBack: '/images/pages/products/redemption-center/b- (2).png',
      },
      {
        briefBack: '/images/pages/products/redemption-center/b- (3).png',
      },
      {
        briefBack: '/images/pages/products/redemption-center/b- (4).png',
      },
    ]
  }
})

</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-redemption-center-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .redemption-center-business-number-cooperative-stores {
    position: absolute;
    top: 120px;
    right: 0;
    display: flex;
    width: 16.5rem;
    height: 5.32rem;
    padding-top: 20px;
    padding-left: 30px;
    border-radius: 0;
    background-image: url("/images/pages/products/redemption-center/Frame 2147229605@2x.png");
    background-size: cover;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 5px;
        left: 0;
        width: 19px;
        height: 19px;
        background-image: url("/images/pages/products/redemption-center/圆点.png");
        background-size: cover;
        content: "";
      }
    }
  }
}

.redemption-center-product-advantage {
  background-image: url("/images/pages/products/redemption-center/product_bottom_next.png");
  background-size: cover;
}

.accordion-container {
  display: flex;
  height: 300px;
  gap: 1rem;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
